/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;

